<template>
  <div class="">
    <div style="margin-bottom:10px;background:#fff;padding:10px 25px">
        <span style="cursor: pointer;" @click="backIndex()"><a-icon type="right" /> 全部文件</span>
        <span v-if="queryParam.catalogId != ''" style="cursor: pointer;">
          <a-icon type="right" />
          <span @click="back()">返回上一级</span>
        </span>
    </div>
    <a-card :bordered="false">
      
      <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin:0px;padding:16px 25px;overflow:hidden;">
        <a-upload
          name="file"
          :multiple="true"
          :action="uploadAction"
          :headers="headers"
          @change="handleChange"
          :showUploadList="false"
          :data="data"
        >
          <a-button type="primary" icon="cloud-upload" style="padding: 0px 11px;" v-has="'cloud:upload'">上传</a-button>
        </a-upload>
        <a-button @click="handleAdd" type="primary" icon="plus" style="padding: 0px 11px;" v-has="'cloud:dir'">新建文件夹</a-button>
        <a-button @click="download" type="primary" icon="cloud-download" style="padding: 0px 11px;" v-has="'cloud:download'">离线下载</a-button>

        <a-button-group>
          <a-button type="primary" ghost style="border-right:0px;transition-duration: 0s;margin-right:0px" @click="delTo" v-has="'cloud:delete'">删除</a-button>
          <a-button type="primary" ghost  @click="editTo" style="border-right:0px;transition-duration: 0s;margin-right:0px" v-if="selectedRowKeys.length==1" v-has="'cloud:rename'">重命名</a-button>
          <a-button type="primary" ghost @click="moveTo" style="transition-duration: 0s;" v-has="'cloud:move'">移动到</a-button>

        </a-button-group>

        <!-- <a-button type="primary" icon="download" @click="handleExportXls('elinkx_cloud_catalog')">导出</a-button> -->
        <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
        <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
        <div class="input-form">
          <a-input-search placeholder="搜索" style="width: 200px;border-radius:30px" @search="onSearch" v-model="queryParam.keywords"/>
        </div>
      </div>

      <!-- table区域-begin -->
      <div>
        <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :pagination="false"
          :columns="columns"
          :dataSource="dataSource"
          :loading="loading"
          @change="handleTableChange"
          :expandedRowKeys="expandedRowKeys"
          @expand="handleExpand"
          v-bind="tableProps"
        >

          <!-- :pagination="ipagination" -->

          <span slot="fileName" slot-scope="text, record">
            <span v-if="record.fileType == 'c'" @click="openFileder(record)" style="cursor: pointer;">
              <a-icon type="folder" :style="{ fontSize: '20px', color: '#ffd55a',verticalAlign: 'middle' }" theme="filled" />
              <span style="margin-left:10px;vertical-align: middle;">{{ text }}</span>
            </span>
            <span v-if="record.fileType == 'f'" style="cursor: pointer;" @click="handlePreview(record)">
              <a-icon type="file-text" :style="{ fontSize: '20px', color: '#ffd55a',verticalAlign: 'middle' }" />
              <span style="margin-left:10px;vertical-align: middle;">{{ text }}</span>
            </span>
          </span>

          <template slot="imgSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img
              v-else
              :src="getImgView(text)"
              height="25px"
              alt=""
              style="max-width:80px;font-size: 12px;font-style: italic;"
            />
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
            <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
              下载
            </a-button>
          </template>

          <!-- <span slot="action" slot-scope="text, record"> -->
            <!-- <a @click="handlePreview(record)" v-if="record.fileType=='f'">预览</a> -->
            <!-- <a-divider type="vertical" /> -->
            <!-- <a @click="handleEdit(record)">重命名</a> -->
            <!-- <a-divider type="vertical" /> -->
            <!-- <a @click="handleMove(record)">移动</a> -->
            <!-- <a-divider type="vertical" /> -->
            <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteNode(record)">
              <a>删除</a>
            </a-popconfirm> -->
            <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAddChild(record)">添加下级</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteNode(record)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
          <!-- </span> -->
        </a-table>
      </div>

      <elinkxCloudCatalog-modal ref="modalForm" @ok="modalFormOk"></elinkxCloudCatalog-modal>
      <elinkxCloudCatalogMove-modal ref="moveModalForm" @ok="modalFormOk"></elinkxCloudCatalogMove-modal>
      
    </a-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

import { getAction, deleteAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ElinkxCloudCatalogModal from './modules/ElinkxCloudCatalogModal'
import ElinkxCloudCatalogMoveModal from './modules/ElinkxCloudCatalogMoveModal'

import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

import {catalogDownload} from '../../api/api'

export default {
  name: 'ElinkxCloudCatalogList',
  mixins: [JeecgListMixin],
  components: {
    ElinkxCloudCatalogModal,
    ElinkxCloudCatalogMoveModal
  },
  data() {
    return {
      uploadAction: window._CONFIG['domianURL'] + '/pc/cloud/upload',
      description: 'elinkx_cloud_catalog管理页面',
      // 表头
      columns: [
        {
          title: '目录名称',
          dataIndex: 'fileName',
          scopedSlots: { customRender: 'fileName' }
        },

        {
          title: '更新人',
          dataIndex: 'realname'
        },
        // {
        //   title:'创建时间',
        //   align:"left",
        //   dataIndex: 'createTime',
        //   customRender:function (text) {
        //     return !text?"":(text.length>10?text.substr(0,10):text)
        //   }
        // },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          }
        },
        {
          title: '大小',
          dataIndex: 'fileSize',
          customRender: function(text, record) {
            return record.fileType == 'c' ? '-' : text
          }
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        // list: "/pc/cloudCatalog/rootList",
        list: '/pc/cloud/list',
        childList: '/pc/cloudCatalog/childList',
        delete: '/pc/cloud/deleteBatch',
        deleteBatch: '/pc/cloudCatalog/deleteBatch',
        exportXlsUrl: '/pc/cloudCatalog/exportXls',
        importExcelUrl: 'pc/cloudCatalog/importExcel'
      },
      expandedRowKeys: [],
      hasChildrenField: 'hasChild',
      pidField: 'parentId',
      dictOptions: {},
      loadParent: false,
      queryParam: {
        pageSize: 1000,
        keywords: '',
        catalogId: this.$route.query.catalogId ? this.$route.query.catalogId : ''
      },
      headers: '',
      data: {
        catalogId: this.$route.query.catalogId ? this.$route.query.catalogId : ''
      }
    }
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN)
    this.headers = { 'X-Access-Token': token, 'X-Access-Admin': 'admin' }
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },

    tableProps() {
      let _this = this;
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: selectedRowKeys => (_this.selectedRowKeys = selectedRowKeys)
        }
      }
    }
  },
  methods: {
    download(){
      if(this.selectedRowKeys.length==0){
        this.$message.warning("至少选择一条数据");
        return;
      }

      let ks = this.selectedRowKeys.join(',')

      window.open(_CONFIG.domianURL+'/pc/cloud/download?ids='+ks,'_blank');

      
    },
    delTo(){
      if(this.selectedRowKeys.length==0){
        this.$message.warning("至少选择一条数据");
        return;
      }
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }

      let ks = this.selectedRowKeys.join(',')

      var that = this

      this.$confirm({
        title: '提示',
        content: "确定删除吗？",
        onOk() {
          deleteAction(that.url.delete, { ids: ks }).then(res => {
            if (res.success) {
              that.loadData(1);
            } else {
              that.$message.warning(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
        class: 'test',
      });

      
    },
    moveTo(record){
      if(this.selectedRowKeys.length==0){
        this.$message.warning("至少选择一条数据");
        return;
      }
      this.$refs.moveModalForm.getCatalogTree(this.selectedRowKeys);
    },
    editTo(){
      let obj = {};
      this.dataSource.map((item,i)=>{
        if(item.id==this.selectedRowKeys[0]){
          obj = item;
        }
      })
      this.handleEdit(obj);
    },
    onSearch(){
      this.loadData()
    },
    backIndex() {
      this.$router.push({
        path: '/views/cloud/ElinkxCloudCatalogList',
        query: {}
      })
    },
    back() {
      this.$router.go(-1)
    },
    // 打开文件夹
    openFileder(record) {
      this.$router.push({
        path: '/views/cloud/ElinkxCloudCatalogList',
        query: {
          catalogId: record.id
        }
      })
    },
    handleChange(info) {
      console.log('--文件列表改变--')
      let fileList = info.fileList
      if (info.file.status === 'done') {
        this.loadData()
      }
    },

    loadData(arg) {
      
      this.selectedRowKeys = [];
      if (arg == 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      this.expandedRowKeys = []
      let params = this.getQueryParams()
      return new Promise(resolve => {
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            let result = res.result
            this.dataSource = res.result
            // if(Number(result.total)>0){
            //   this.ipagination.total = Number(result.total)
            //   this.dataSource = this.getDataByResult(res.result.records)
            //   resolve()
            // }else{
            //   this.ipagination.total=0
            //   this.dataSource=[]
            // }
          } else {
            this.$message.warning(res.message)
          }
          this.loading = false
        })
      })
    },
    getDataByResult(result) {
      return result.map(item => {
        //判断是否标记了带有子节点
        if (item[this.hasChildrenField] == '1') {
          let loadChild = { id: item.id + '_loadChild', name: 'loading...', isLoading: true }
          item.children = [loadChild]
        }
        return item
      })
    },
    handleExpand(expanded, record) {
      // 判断是否是展开状态
      if (expanded) {
        this.expandedRowKeys.push(record.id)
        if (record.children.length > 0 && record.children[0].isLoading === true) {
          let params = this.getQueryParams() //查询条件
          params[this.pidField] = record.id
          getAction(this.url.childList, params).then(res => {
            if (res.success) {
              if (res.result && res.result.length > 0) {
                record.children = this.getDataByResult(res.result)
                this.dataSource = [...this.dataSource]
              } else {
                record.children = ''
                record.hasChildrenField = '0'
              }
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      } else {
        let keyIndex = this.expandedRowKeys.indexOf(record.id)
        if (keyIndex >= 0) {
          this.expandedRowKeys.splice(keyIndex, 1)
        }
      }
    },
    initDictConfig() {},
    modalFormOk(formData, arr) {
      this.loadData()
      // if(!formData.id){
      //   this.addOk(formData,arr)
      // }else{
      //   if(!arr){
      //     this.loadData()
      //   }else{
      //     this.editOk(formData,this.dataSource)
      //     this.dataSource=[...this.dataSource]
      //   }
      // }
    },
    editOk(formData, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == formData.id) {
            arr[i] = formData
            break
          } else {
            this.editOk(formData, arr[i].children)
          }
        }
      }
    },
    async addOk(formData, arr) {
      if (!formData[this.pidField]) {
        this.loadData()
      } else {
        if (this.loadParent === true) {
          this.expandTreeNode(formData[this.pidField])
          this.loadParent = false
        } else {
          this.expandedRowKeys = []
          for (let i of arr) {
            await this.expandTreeNode(i)
          }
        }
      }
    },
    expandTreeNode(nodeId) {
      return new Promise((resolve, reject) => {
        this.getFormDataById(nodeId, this.dataSource)
        let row = this.parentFormData
        this.expandedRowKeys.push(nodeId)
        let params = this.getQueryParams() //查询条件
        params[this.pidField] = nodeId
        getAction(this.url.childList, params).then(res => {
          if (res.success) {
            if (res.result && res.result.length > 0) {
              row.children = this.getDataByResult(res.result)
            } else {
              row.children = ''
            }
            this.dataSource = [...this.dataSource]
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getFormDataById(id, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            this.parentFormData = arr[i]
          } else {
            this.getFormDataById(id, arr[i].children)
          }
        }
      }
    },
    handleAddChild(record) {
      this.loadParent = true
      let obj = {}
      obj[this.pidField] = record['id']
      this.$refs.modalForm.add(obj)
    },
    //预览
    handlePreview(record) {
      if (record && record.url) {
        let url = window._CONFIG['onlinePreviewDomainURL'] + '?url=' + encodeURIComponent(record.url)
        window.open(url, '_blank')
      }
    },
    handleDeleteNode(record) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { ids: record.id }).then(res => {
        if (res.success) {
          if (!record[this.pidField] || record[this.pidField] == '0' || record[this.pidField].length == 0) {
            that.loadData(1)
          } else {
            that.$message.success(res.message)
            that.expandTreeNode(record[this.pidField])
          }
        } else {
          that.$message.warning(res.message)
        }
      })
    }
  },
  watch: {
    $route() {
      this.queryParam.catalogId = this.$route.query.catalogId ? this.$route.query.catalogId : ''
      this.data.catalogId = this.$route.query.catalogId ? this.$route.query.catalogId : ''
      this.loadData()
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.input-form{
    float: right;
}
:global .ant-input{
    border-radius: 30px;
}

</style>

